import React from 'react'
import { ChatDrawer } from '@web/modules/core'
import { useSendOrderMessageWeb } from '@web/modules/send-order-message/hooks'
import { SendOrderFormMessage } from '@web/modules/send-order-message/components'

const SendOrderMessage = () => {
  const { chatId, isSubmitting, handleSendOrderMessage, handleClose } = useSendOrderMessageWeb()

  return (
    <div>
      {chatId && (
        <ChatDrawer
          headerTitle='Enviar cobrança'
          open={true}
          onClose={handleClose}
          anchorPosition='right'
        >
          <div className='mx-deca'>
            <SendOrderFormMessage
              chatId={chatId}
              isSubmitting={isSubmitting}
              onConfirm={handleSendOrderMessage}
              onCancel={handleClose}
            />
          </div>
        </ChatDrawer>
      )}
    </div>
  )
}

export default SendOrderMessage
